"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (model) => {
    switch (model) {
        case "premium":
        case "vip":
            return null;
        case "plus":
            return 3;
        case "pro":
        case "original":
            return 1;
        // TODO: Which default state should be set? Temporarly set to null
        default:
            return null;
    }
};
//# sourceMappingURL=NumberOfCoachingDays.js.map